module.exports = __webpack_public_path__ + "img/text_click_to_clockin.449dde7e.png";